import React from "react"

import { Stack, Typography } from "@mui/material"
import { makeStyles } from "@mui/styles"
import { StyledContainer, StyledErrorMessage } from "../styledComponents"
import clsx from "clsx"
import { COLORS } from "../../../utils"

const useStyles = makeStyles({
  stackStyle: {
    border: "1px solid #E6E6E6",
    padding: "24px",
    gap: "24px",
    borderRadius: "8px",
    marginBottom: "24px"
  },
  iconContainer: {
    height: 52,
    width: 52,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#CED8F5",
    borderRadius: "8px",
    "& img": {
      height: 24
    }
  }
})

const ProductionStepExecutionCardContainer = ({ title, subtitle, children, error, style = {}, icon = "/img/recipes/weight.svg", readOnly = false }) => {
  const classes = useStyles()
  return (<Stack gap={2} className={classes.stackStyle} sx={{ border: error && `2px solid ${COLORS.RED_ERROR} !important`, marginTop: "24px", ...style }}>
    <StyledContainer>
      <Stack sx={{ p: 0 }} gap={3}>
        <Stack
          direction="row"
          gap={1}>
          <div className={clsx(classes.iconContainer, "iconContainer")} style={{ backgroundColor: readOnly ? "#F5F5F5" : "#CED8F5" }}>
            <img src={icon} />
          </div>
          <div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
            <Typography sx={{
              color: COLORS.BLACK800,
              fontSize: 20,
              fontWeight: 500,
              lineHeight: "28px"
            }}>
              {title}
            </Typography>
            {!readOnly && subtitle && <Typography sx={{
              color: COLORS.BLACK_600,
              fontSize: 18,
              lineHeight: "28px"
            }}>
              {subtitle}
            </Typography>}
          </div>
        </Stack>
        {children}
      </Stack>
    </StyledContainer>
    {error && (
      <StyledErrorMessage>{error}</StyledErrorMessage>
    )}
  </Stack>)
}

export default ProductionStepExecutionCardContainer